import React, { useEffect, useState } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import httpService from "../../../../../services/httpServices/httpServices";
import helperNumber from "../../../../../helpers/numbers";
import helperSpinner from "../../../../../helpers/spinner";

function EditNative() {
  const params = useParams();
  const history = useHistory();
  const advertiseNativeID = params.id;
  useEffect(() => {
    getAdvertiseNativeUser(advertiseNativeID);
  }, []);

  const initAdvertiseNativeUser = {
    adv_active: null,
    adv_campaign_id: null,
    adv_confirm: null,
    adv_created_at: null,
    adv_deleted_at: null,
    adv_id: null,
    adv_type: null,
    adv_updated_at: null,
    adv_user_id: null,
    files: null,
    title: null,
    link: null,
    message: null,
  };

  const prefixLinkNativeAdvertise =
    process.env.REACT_APP_DOMAIN_API +
    "/" +
    process.env.REACT_APP_URL_ADVERTISE_FILES +
    "/native";

  const [advertiseNativeUser, setAdvertiseNativeUser] = useState(
    initAdvertiseNativeUser
  );
  const [advertiseNativeImage, setAdvertiseNativeImage] = useState(<></>);

  const getAdvertiseNativeUser = async (advertiseNativeID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    const advertiseNativeUser = await sendRequestGetAdvertiseNativeUser(
      advertiseNativeID
    );
    setAdvertiseNativeUser(advertiseNativeUser);

    const linkImage =
      prefixLinkNativeAdvertise + "/" + advertiseNativeUser.files;
    setAdvertiseNativeImage(<img className="img-fluid" src={linkImage} />);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  };

  const sendRequestGetAdvertiseNativeUser = async (advertiseNativeID) => {
    const headersRequest = getHeaderForRequest();
    let advertiseNativeUserInfo;
    try {
      advertiseNativeUserInfo = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/advertise/manage/native/" +
          advertiseNativeID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return advertiseNativeUserInfo.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  let tagConfirm;
  if (advertiseNativeUser.adv_confirm != null) {
    let classNameConfirmAdvertise = "";
    let textConfirmAdvertise = "";
    switch (advertiseNativeUser.adv_confirm) {
      case 0:
        classNameConfirmAdvertise = "warning";
        textConfirmAdvertise = "در حال بررسی";
        break;
      case 1:
        classNameConfirmAdvertise = "success";
        textConfirmAdvertise = "تایید شده";
        break;
      case 2:
        classNameConfirmAdvertise = "danger";
        textConfirmAdvertise = "رد شده";
        break;
    }

    tagConfirm = (
      <span className={`badge badge-${classNameConfirmAdvertise}`}>
        {textConfirmAdvertise}
      </span>
    );
  }

  let tagActive;
  if (advertiseNativeUser.adv_active != null) {
    let classNameStateAdvertise = advertiseNativeUser.adv_active
      ? "success"
      : "danger";
    let textStateAdvertise = advertiseNativeUser.adv_active
      ? "فعال"
      : "غیر فعال";
    tagActive = (
      <span className={`badge badge-${classNameStateAdvertise} `}>
        {textStateAdvertise}
      </span>
    );
  }

  const sendForm = async (e) => {
    e.preventDefault();

    let messageText = document.querySelector("#message").value;

    if (messageText == "") {
      alert("لطفا دلیل رد شدن تبلیغ  را وارد کنید.");
      return;
    }

    let data = {
      confirm: "2",
      message: messageText,
    };

    if (await sendRequestEditAdvertiseNativeUser(advertiseNativeID, data)) {
      history.push("/advertise/manage/native/all");
    }
  };

  const confirmAdvertiseNativeUser = async () => {
    const data = {
      confirm: "1",
    };
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (await sendRequestEditAdvertiseNativeUser(advertiseNativeID, data)) {
      history.push("/advertise/manage/native/all");
    }
  };

  const sendRequestEditAdvertiseNativeUser = async (
    advertiseNativeID,
    data
  ) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/advertise/manage/native/" +
          advertiseNativeID,
        data,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  if (advertiseNativeUser.message) {
    document.querySelector("#message").value = advertiseNativeUser.message;
  }

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  اطلاعات تبلیغ بنری حذف شده
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="text-left">
                <Link
                  to="/advertise/manage/native/all"
                  className="btn btn-primary"
                >
                  <span className="pl-2">بازگشت</span>
                  <span>
                    <i className="fa fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              <div className="table-responsive pt-1">
                <table className="table table-bordered table-dark tbl-td-white-space table-hover">
                  <tbody>
                    <tr>
                      <td> شماره تبلیغ </td>
                      <td>
                        {helperNumber.toPersianNum(advertiseNativeUser.adv_id)}
                      </td>
                    </tr>
                    <tr>
                      <td>شماره کاربری </td>
                      <td>
                        {helperNumber.toPersianNum(
                          advertiseNativeUser.adv_user_id
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>آدرس صفحه فرود</td>
                      <td>
                        <a
                          className="btn btn-primary"
                          target="_blank"
                          href={advertiseNativeUser.link}
                        >
                          <i class="fa fa-globe"></i>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>عنوان</td>
                      <td>{advertiseNativeUser.title}</td>
                    </tr>
                    <tr>
                      <td> شماره کمپین </td>
                      <td>
                        {helperNumber.toPersianNum(
                          advertiseNativeUser.adv_campaign_id
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td> وضعیت </td>
                      <td>{tagActive}</td>
                    </tr>
                    <tr>
                      <td> بررسی </td>
                      <td>{tagConfirm}</td>
                    </tr>
                    <tr>
                      <td> تاریخ ایجاد </td>
                      <td>
                        {helperNumber.toPersianNum(
                          advertiseNativeUser.adv_created_at
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td> تاریخ بروزرسانی </td>
                      <td>
                        {helperNumber.toPersianNum(
                          advertiseNativeUser.adv_updated_at
                        )}
                      </td>
                    </tr>

                    <tr>
                      <td> تاریخ حذف </td>
                      <td>
                        {" "}
                        {helperNumber.toPersianNum(advertiseNativeUser.adv__at)}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div
                  className="d-flex  flex-column align-items-center"
                  id="img-upload-natives-container"
                >
                  {advertiseNativeImage}
                </div>
                <hr />
                <div>
                  <form onSubmit={sendForm}>
                    <div class="form-group">
                      <label>
                        دلیل رد شدن تبلیغ (این متن برای کاربر ارسال میشود)
                      </label>
                      <textarea
                        class="form-control"
                        id="message"
                        rows="4"
                        cols="50"
                      >
                        {advertiseNativeUser.message}
                      </textarea>
                    </div>
                    <div className="pb-3">
                      <button className="btn btn-danger">رد تبلیغ</button>
                    </div>
                  </form>
                  <hr />
                  <div>
                    <button
                      onClick={confirmAdvertiseNativeUser}
                      className="btn btn-success"
                    >
                      تایید تبلیغ
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default EditNative;
